import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Grid,
  Switch,
  LinearProgress
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import {
  getStoreProductsByCategoryApi,
  getStoreProductsApi,
  getStoreCategoriesApi
} from 'api';
import {changeCategoryProducts} from 'redux/actions/products';
import {changeHomepagePromoCarouselConfig, changeHomepagePromoButtonCategory} from 'redux/actions/store_configs';
import { changeHomepageCategory } from 'redux/actions/categories';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';


const PromoCategory = ({categoryId, index, onError, error}) => {
  const dispatch = useDispatch();
  const {
    store_products,
    category_products,
    categoryProductsLoading,
    categoryProductsError,
    productsLoading,
    productsError
  } = useSelector((state) => state.products);
  const {homepageCategoriesConfigs} = useSelector((state) => state.store_configs);
  const userStore = useSelector((state) => state.user?.profile?.stores?.[0]);
  const {
    storeActiveCategoriesWithActiveNavLevel,
    loadingCategories,
    errorCategories
  } = useSelector((state) => state.categories);

  const isPremiumStore = userStore?.storeType === 'premium' || userStore?.storeType === 'modern_premium';
  const isPremiumPlusStore = userStore?.storeType === 'premium_plus' || userStore?.storeType === 'modern_premium_plus';
  const isSkinCeuticals = userStore?.storeType === 'skinceuticals';

  const layoutType = (isPremiumStore || isPremiumPlusStore) ? 'Carousel' : 'Tab';

  const title = !!homepageCategoriesConfigs.length &&
    homepageCategoriesConfigs.find((config) => config.path === `store_info/home_tabs/carousel_${index}_title`).value;

  const isCarouselButtonEnable = !!homepageCategoriesConfigs.length &&
  homepageCategoriesConfigs.find((config) => config.path === `store_info/home_tabs/is_button_${index}_enabled`).value == 1;

  const carouselCTAButtonTitle = !!homepageCategoriesConfigs.length &&
  homepageCategoriesConfigs.find((config) => config.path === `store_info/home_tabs/button_${index}_title`).value;

  const buttonCategoryId = !!homepageCategoriesConfigs.length &&
    homepageCategoriesConfigs.find((config) => config.path === `store_info/home_tabs/button_${index}_category_id`).value;

  useEffect(() => {
    if (!category_products[categoryId]) {
      getStoreProductsByCategoryApi({dispatch, categoryId});
    }

    if (store_products.catalogProducts.length === 0 && userStore?.isCreated) {
      getStoreProductsApi({dispatch});
    }

    if (!storeActiveCategoriesWithActiveNavLevel.length) {
      getStoreCategoriesApi({dispatch, checkStoreType: false});
    }
  }, []);

  useEffect(() => {
    checkAllTabsValue();
  }, [
    storeActiveCategoriesWithActiveNavLevel,
    isCarouselButtonEnable,
    carouselCTAButtonTitle,
    buttonCategoryId,
    title,
  ]);

  const handleSelect = (event, value, actionName, option) => {
    dispatch(changeCategoryProducts(actionName, categoryId, option.option));
  };

  const handleSelectButtonCategory = (event, value, actionName, option, targetPath) => {
    dispatch(changeHomepagePromoButtonCategory(actionName, targetPath, value?.id));
  };

  const handleChange = (event) => {
    const {name, checked, type, value} = event.target;
    dispatch(changeHomepagePromoCarouselConfig(name, checked, type, value));
  };

  const handleChangeHomepageCategory = (event) => {
    const {name, checked, type, value} = event.target;

    if (type === 'checkbox') {
      dispatch(changeHomepageCategory(Number.parseInt(categoryId), 'is_active', checked, name));
      dispatch(changeHomepageCategory(
        Number.parseInt(categoryId),
        'name',
        title,
        name
      ));
    }

    if (type === 'text') {
      dispatch(changeHomepageCategory(Number.parseInt(categoryId), 'name', value, name));
    }
  };

  const checkAllTabsValue = () => {
    if (
      (isCarouselButtonEnable && buttonCategoryId === ('' || null)) ||
      (isCarouselButtonEnable && carouselCTAButtonTitle === '') ||
      (!title)
    ) {
      onError({...error, [`errorTab${index}`]: true});
    } else {
      onError({...error, [`errorTab${index}`]: false});
    }
  };

  return (
    <div className="m-10">
      <Grid container spacing={3}>
        <Grid item xs={12} sm={2} className="my-2 ml-4">Enable {layoutType}</Grid>
        <Grid item xs={12} sm={9}>
          <Switch
            color="primary"
            name={`store_info/home_tabs/is_carousel_${index}_enabled`}
            checked={homepageCategoriesConfigs.find((config) => config.path === `store_info/home_tabs/is_carousel_${index}_enabled`).value == 1}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={2} className="ml-4">Title for {layoutType}</Grid>
        <Grid item xs={12} sm={9}>
          <TextField
            required
            fullWidth
            variant="outlined"
            label="Title"
            defaultValue={title}
            name={`store_info/home_tabs/carousel_${index}_title`}
            onChange={handleChangeHomepageCategory}
            helperText={(!title?.length) && 'Field is required'}
            error={Boolean(!title?.length)}
          />
        </Grid>
        <Grid item xs={12} sm={2} className="ml-4">Products in {layoutType}</Grid>
        <Grid item xs={12} sm={9}>
          {
            (categoryProductsLoading ||
            productsLoading) &&
            <LinearProgress />
          }
          {
            !categoryProductsLoading &&
            !productsLoading &&
            categoryProductsError &&
            productsError &&
            <div>Can&apos;t fetch products data</div>
          }
          {!categoryProductsLoading &&
           !productsLoading &&
            store_products.catalogProducts &&
            category_products[categoryId] &&
            <Autocomplete
              multiple
              fullWidth
              disableClearable
              value={category_products[categoryId].catalogProducts}
              options={store_products.catalogProducts}
              getOptionLabel={(option) => option.name}
              filterSelectedOptions
              onChange={(event, value, action, option) => handleSelect(event, value, action, option)}
              getOptionSelected={(option) => category_products[categoryId].catalogProducts.find((el) => el.id === option.id)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label={`Products in ${layoutType}`}
                  placeholder="Add more products..."
                />
              )}
              renderOption={(option, { inputValue }) => {
                const matches = match(option.name, inputValue);
                const parts = parse(option.name, matches);
                return (
                  <div>
                    {parts.map((part, index) => (
                      <span key={index} className={`${part.highlight ? 'text-primary font-bold' : ''}`}>
                        {part.text}
                      </span>
                    ))}
                  </div>
                );
              }}
            />
          }
        </Grid>
        {(isPremiumStore || isPremiumPlusStore || isSkinCeuticals) &&
          <>
            <Grid item xs={12} sm={2} className="my-2 ml-4">Enable CTA Carousel Button</Grid>
            <Grid item xs={12} sm={9}>
              <Switch
                color="primary"
                name={`store_info/home_tabs/is_button_${index}_enabled`}
                checked={isCarouselButtonEnable}
                onChange={handleChange}
              />
            </Grid>

            {isCarouselButtonEnable &&
              <>
                <Grid item xs={12} sm={2} className="ml-4">Button Title</Grid>
                <Grid item xs={12} sm={9}>
                  <TextField
                    required
                    fullWidth
                    variant="outlined"
                    label="Title"
                    defaultValue={carouselCTAButtonTitle}
                    name={`store_info/home_tabs/button_${index}_title`}
                    onChange={handleChange}
                    helperText={(!carouselCTAButtonTitle.length && isCarouselButtonEnable) && 'Field is required'}
                    error={Boolean(!carouselCTAButtonTitle.length && isCarouselButtonEnable)}
                  />
                </Grid>
                <Grid item xs={12} sm={2} className="ml-4">Button Category</Grid>
                <Grid item xs={12} sm={9}>
                  {
                    loadingCategories &&
                    <LinearProgress className="mt-2" />
                  }
                  {
                    !loadingCategories &&
                    errorCategories &&
                    <div>Can&apos;t fetch products data</div>
                  }
                  {!loadingCategories && !errorCategories && storeActiveCategoriesWithActiveNavLevel.length &&
                    <Autocomplete
                      size="small"
                      fullWidth
                      options={storeActiveCategoriesWithActiveNavLevel}
                      getOptionLabel={(option) => option.nameWithPath || ''}
                      value={storeActiveCategoriesWithActiveNavLevel.find((category) => category.id == buttonCategoryId) || null}
                      getOptionSelected={(option) => (
                        homepageCategoriesConfigs.find((config) => (
                          config.path === `store_info/home_tabs/button_${index}_category_id` && config.value == option.id)
                        )
                      )}
                      onChange={(event, value, action, option) => {
                        handleSelectButtonCategory(event, value, action, option, `store_info/home_tabs/button_${index}_category_id`);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          variant="outlined"
                          label="Category"
                          helperText={(!buttonCategoryId && isCarouselButtonEnable) && 'Field is required'}
                          error={Boolean(!buttonCategoryId && isCarouselButtonEnable)}
                        />
                      )}
                      renderOption={(option, { inputValue }) => {
                        const matches = match(option.nameWithPath, inputValue);
                        const parts = parse(option.nameWithPath, matches);
                        return (
                          <div>
                            {parts.map((part, index) => (
                              <span key={index} className={`${part.highlight ? 'text-primary font-bold' : ''}`}>
                                {part.text}
                              </span>
                            ))}
                          </div>
                        );
                      }}
                    />
                  }
                </Grid>
              </>
            }
          </>
        }
      </Grid>
    </div>
  );
};

export default PromoCategory;
